export default __webpack_public_path__ + "static/media/simgecan1.d41598db.jpg";